import React from "react";
import UsersView from "../../../views/dashboard/users";

const Users = () => {
  return <UsersView />;
};

export default Users;
